export const AGENT_PARAM = 'agent'
export const STORAGE_KEY = 'cms:agent:pairing'
export const localCommandId = () => `local-${Date.now().toString(36)}`

export const MUTATING_OPS = [
  'addNode',
  'insertSavedBlock',
  'saveBlock',
  'setProps',
  'setCustom',
  'removeNode',
  'moveNode',
  'duplicateNode',
  'renameNode',
  'setHidden',
  'selectNode',
  'setPattern',
]
export const HISTORY_OPS = ['undo', 'redo']
const READ_OPS = ['outline', 'getNode', 'state', 'changes', 'screenshot']
export const FINAL_OPS = ['save']
export const OPS = [...MUTATING_OPS, ...HISTORY_OPS, ...READ_OPS, ...FINAL_OPS]

export const RESTRICTED_BLOCKS = ['html']
export const DEVICES = ['desktop', 'mobile']
export const STATE_INCLUDES = ['document', 'html', 'css', 'theme', 'patterns']

export const TEXT_PROPS = {
  heading: 'content',
  text: 'content',
  'rich-text': 'content',
  button: 'content',
  link: 'content',
  label: 'content',
  'feedback-message': 'content',
}

export const LIMITS = {
  outlineDepth: 6,
  outlineMaxNodes: 300,
  outlineMaxNodesLimit: 2000,
  touchedOutlineDepth: 4,
  touchedOutlineMaxNodes: 80,
  stateMaxChars: 80_000,
  stateMaxCharsLimit: 400_000,
  revisionLog: 300,
  linkedNodeTimeout: 1500,
  readyTimeout: 10_000,
  settleAfterMutation: 350,
  settleQuiet: 80,
  commandTimeout: 60_000,
  commandTimeoutPerOp: 100,
  snapshotTimeout: 5_000,
  screenshotTimeout: 20_000,
  screenshotMaxWidth: 960,
  screenshotScale: [0.25, 1],
  screenshotCssSettle: 1_000,
}

export const ERRORS = Object.freeze({
  INVALID_OP: 'INVALID_OP',
  INVALID_BATCH: 'INVALID_BATCH',
  UNKNOWN_BLOCK: 'UNKNOWN_BLOCK',
  BLOCK_NOT_ALLOWED: 'BLOCK_NOT_ALLOWED',
  UNKNOWN_VARIANT: 'UNKNOWN_VARIANT',
  UNKNOWN_PATTERN: 'UNKNOWN_PATTERN',
  UNKNOWN_PROP: 'UNKNOWN_PROP',
  INVALID_VALUE: 'INVALID_VALUE',
  NODE_NOT_FOUND: 'NODE_NOT_FOUND',
  AMBIGUOUS_REF: 'AMBIGUOUS_REF',
  LINKED_NODE_NOT_READY: 'LINKED_NODE_NOT_READY',
  PARENT_NOT_CANVAS: 'PARENT_NOT_CANVAS',
  NOT_DELETABLE: 'NOT_DELETABLE',
  NOT_DUPLICABLE: 'NOT_DUPLICABLE',
  MOVE_REJECTED: 'MOVE_REJECTED',
  NOTHING_TO_UNDO: 'NOTHING_TO_UNDO',
  NOTHING_TO_REDO: 'NOTHING_TO_REDO',
  SAVE_FAILED: 'SAVE_FAILED',
  SAVED_BLOCK_NOT_FOUND: 'SAVED_BLOCK_NOT_FOUND',
  NOT_READY: 'NOT_READY',
  REVISION_MISMATCH: 'REVISION_MISMATCH',
  TIMEOUT: 'TIMEOUT',
  INTERNAL: 'INTERNAL',
})

class AgentError extends Error {
  constructor(code, message, details) {
    super(message)
    this.name = 'AgentError'
    this.code = code
    this.details = details
  }
}

export const createError = (code, message, details) => new AgentError(code, message, details)

const isAgentError = error => error instanceof AgentError

export function serializeError(error) {
  if (isAgentError(error)) {
    return { code: error.code, message: error.message, details: error.details }
  }

  return { code: ERRORS.INTERNAL, message: error?.message || String(error) }
}

export function parseError(error) {
  const { response, message } = error || {}
  return String(response?.data?.message || response?.data?.error || message || 'Command failed')
}
